export default function formatDate(value) {
    let date = value.split("T");
    return date[0];
}